export default __webpack_public_path__ + "static/media/ATD.461b1702.gif";